import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(5),
    alignSelf: 'stretch',
  },
  questionText: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraText.tertiary,
  },
  answerText: {
    fontSize: '14px !important',
    fontWeight: 400,
    color: theme.palette.labraText.tertiary,
  },
  qnaContainer: {
    gap: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
  },
  linkText: {
    fontWeight: 500,
    color: theme.palette.select.light,
  },
  link: {
    '& > p': {
      textDecoration: 'none',
    },
    '&:hover': {
      textDecoration: 'none',
    },
  },
  icon: {
    marginLeft: '2px',
  },
  withoutQuestion: {
    marginTop: '-25px',
  },
  roleBadgeLightBlue: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: theme.palette.avatarColors.lightBlue5,
    width: 'fit-content',
    padding: theme.spacing(0.5, 1),
    gap: theme.spacing(1),
    alignItems: 'center',
    borderRadius: theme.spacing(0.5),
  },
  roleBadgePurple: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: theme.palette.avatarColors.purple,
    width: 'fit-content',
    padding: theme.spacing(0.5, 1),
    gap: theme.spacing(1),
    alignItems: 'center',
    borderRadius: theme.spacing(0.5),
  },
  personaBadgeIcon: {
    height: theme.spacing(1.62),
    color: theme.palette.button.primary,
  },
  personaBadgeLabel: {
    fontWeight: 500,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.spacing(1.75),
    lineHeight: theme.spacing(2.5),
    color: theme.palette.labraText.primary,
  },
  personaWithNoQuestion: {
    marginBottom: theme.spacing(-3.5),
  },
}))
